var map = {
	"./music-instructions.json": 4437,
	"./music-library-intro2024.json": 4438,
	"./music-library-launch2024.json": 4439,
	"./music-progression.json": 4440,
	"./startSourcesAdvanced.json": 4441,
	"./startSourcesSimple.json": 4442,
	"./startSourcesSimple2.json": 4443,
	"./startSourcesTracks.json": 4444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4215;